import { Component, Inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AdminService } from '../../services/AdminService/admin';
import { extractErrorMessage } from '../../shared/error-utils';
import { ErrorBanner } from '../../shared/components/error-banner/error-banner';

export interface SuspendCompanyDialogData {
  companyId: string;
  companyName: string;
}

@Component({
  selector: 'app-suspend-company-dialog',
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    ErrorBanner,
  ],
  templateUrl: './suspend-company-dialog.html',
  styleUrl: './suspend-company-dialog.scss',
})
export class SuspendCompanyDialog {
  reason = '';
  isSubmitting = signal(false);
  errorMessage = signal('');

  constructor(
    private dialogRef: MatDialogRef<SuspendCompanyDialog>,
    private admin: AdminService,
    @Inject(MAT_DIALOG_DATA) public data: SuspendCompanyDialogData
  ) {}

  cancel(): void {
    this.dialogRef.close();
  }

  submit(): void {
    if (!this.reason.trim()) {
      return;
    }

    this.isSubmitting.set(true);
    this.errorMessage.set('');

    this.admin.suspend(this.data.companyId, { reason: this.reason }).subscribe({
      next: () => {
        this.isSubmitting.set(false);
        this.dialogRef.close(true);
      },
      error: (err: HttpErrorResponse) => {
        this.isSubmitting.set(false);
        this.errorMessage.set(extractErrorMessage(err, 'Failed to suspend company.'));
      },
    });
  }
}
